import { createSlice } from "@reduxjs/toolkit";
import { formattedSamplesConfigs } from "../helpers/utils";
import { fetchDevicesConfigs } from "./devicesConfigsDuck";
import { upsertAlarmsForMap } from "./alarmsDuck";
import { mergeFormattedEntries } from "../helpers/utils";
import { fetchEdgeDataSocket } from "./devicesDuck";

export const samplesDefaultState = {
  entries: {},
  formattedEntries: {},
  extraDiagnostics: {},
  dataTimeStamp: 0,
};

const samplesSlice = createSlice({
  name: "samples",
  initialState: samplesDefaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDevicesConfigs.fulfilled, (state, action) => {
        const { samples } = action.payload.response;
        const formattedSampleConfigs = formattedSamplesConfigs(samples);
        // Seed formattedEntries with config defaults so the selector can generate the initial sample list
        state.formattedEntries = formattedSampleConfigs;
      })
      .addCase(upsertAlarmsForMap.fulfilled, (state, action) => {
        // Alarm data is stored in alarmsDuck; samplesList is now derived by selector
      })
      .addCase(fetchEdgeDataSocket.fulfilled, (state, action) => {
        const { data, dataTimeStamp, samplesConfigs } = action.payload;
        if (!samplesConfigs) { return; }
        state.dataTimeStamp = dataTimeStamp;
        state.formattedEntries = mergeFormattedEntries(data, state.formattedEntries, samplesConfigs);

        data.forEach(dataObject => {
          if (samplesConfigs[dataObject.HwId] && !samplesConfigs[dataObject.HwId][dataObject.ValueName]) {
            const diagValue = isNaN(dataObject.Value) ? dataObject.Value : Number(dataObject.Value).toFixed(2);
            const preValues =
              state.extraDiagnostics && state.extraDiagnostics[dataObject.HwId]
                ? { ...state.extraDiagnostics[dataObject.HwId] }
                : {};
            state.extraDiagnostics = {
              ...state.extraDiagnostics,
              [dataObject.HwId]: {
                ...preValues,
                [dataObject.ValueName]: {
                  displayName: dataObject.ValueName,
                  value: dataObject.ValueString ? dataObject.ValueString + "  -  " + diagValue : diagValue,
                  unit: dataObject.Unit,
                  hwId: dataObject.HwId,
                },
              },
            };
          }
        });
      });
  },
});

export const { } = samplesSlice.actions;

export default samplesSlice.reducer;
